export default defineNuxtPlugin(() => {
    const cookie = useCookie<string | null>('design_palette_preview', { path: '/', sameSite: 'lax' })
    const previewEnabled = useState<boolean>('palette-preview-enabled', () => false)
    const enable = new URLSearchParams(window.location.search).get('enable_palette')

    previewEnabled.value = enable === 'true' || enable === '1'
        ? true
        : enable === 'false' || enable === '0' ? false : Boolean(cookie.value)

    onNuxtReady(() => {
        if (!cookie.value && !window.location.search.includes('enable_palette=')) return

        const url = new URL(window.location.href)
        const enable = url.searchParams.get('enable_palette')

        if (enable !== null) {
            if (enable === 'true' || enable === '1') {
                const id = url.searchParams.get('design_template_id')
                cookie.value = id && /^[1-9]\d*$/.test(id) ? id : 'enabled'
            } else if (enable === 'false' || enable === '0') {
                cookie.value = null
            }

            url.searchParams.delete('enable_palette')
            url.searchParams.delete('design_template_id')
            window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
        }

        previewEnabled.value = Boolean(cookie.value)
    })
})
